function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import styled from 'styled-components';
import { get } from '../../constants';
import sx from '../../sx';
/**
 * Use the LinkWithIcon component to style an anchor tag with anchor tags with platform hyperlink color cues and hover text decoration,
 * while also respecting accessibility.
 *
 * When choosing a link or a button, links are used for destinations, whenever the action may refresh the browers,
 * or when moving from one page to another.
 *
 * The LinkWithIcon component can be used as a semantic `button`, by using `<LinkWithIcon as='button' onClick={your onClick here}>.
 *
 * If you use the `as` prop, be sure to pass the inclusive and semantically correct element, such as an `a`, `button`, or
 * `summary` tag.
 */

const LinkWithIcon = ({
  icon,
  variant = 'iconAfter',
  iconSize = 16,
  children,
  ...delegated
}) => {
  let Component;
  switch (variant) {
    case 'iconBefore':
      Component = LinkWithIconBefore;
      break;
    case 'iconAfter':
      Component = LinkWithIconAfter;
      break;
    default:
      throw new Error(`unrecognized ${variant}, please use 'iconBefore' or 'iconAfter' variant with LinkWithIcon.`);
  }
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    style: {
      '--size': iconSize + 'px'
    }
  }, delegated), /*#__PURE__*/React.createElement(Component, {
    icon: icon
  }, children));
};
LinkWithIcon.displayName = "LinkWithIcon";
const LinkWithIconBefore = ({
  ...props
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.icon, props.children);
};
const LinkWithIconAfter = ({
  ...props
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.children, props.icon);
};
const Wrapper = styled.a.withConfig({
  displayName: "LinkWithIcon__Wrapper",
  componentId: "sc-1o3szlh-0"
})(["color:", ";text-decoration:", ";font-weight:", ";&:hover{cursor:pointer;background:none;text-decoration:underline;transition-duration:0s,0.15s;", "}&:active{background:none;transition-duration:0s;color:", ";}&:focus{background:none;box-shadow:0 0 0 2px ", ";transition-duration:0s,0.2s;color:", ";}&:is(button){display:inline-block;padding:0;margin:0;font-size:inherit;white-space:nowrap;cursor:pointer;user-select:none;background-color:transparent;border:0;appearance:none;}& > svg{width:var(--size);height:var(--size);display:inline-block;user-select:none;vertical-align:text-bottom;overflow:visible;}", ""], p => p.subtle ? get('colors.text.subtlest') : get('colors.link.default'), p => p.underline ? 'underline' : 'none', get('fontWeights.bold'), p => p.subtle ? `${get('colors.text.subtlest')}` : '', get('colors.link.pressed'), get('colors.border.focused'), get('colors.text.subtle'), sx);
export default LinkWithIcon;